<template>
	<div class="keyboard" @mouseup="mouse_up()">

		<!-- <transition-group name="key" tag="div" class="letters"> -->
		<div class="letters">
			<div v-for="touch in keyboard" class="slot" :class="{ empty: !touch.letter }">
				<key v-if="touch.letter" :touch="touch" @mousedown.native="keydown(touch)" @mouseup.native="keyup(touch)" />
			</div>
		</div>
		<!-- </transition-group> -->

		<div class="keys">
			<!-- <div class="slot shuffle" @mousedown="shuffle_down();"><div class="key" :class="{ pressed: shuffle_pressed }"><icon file="refresh-cw" /></div></div> -->
			<div class="slot left" @mousedown="left_down();"><div class="key" :class="{ pressed: left_pressed }"><icon file="arrow-left" /></div></div>
			<div class="slot right" @mousedown="right_down();"><div class="key" :class="{ pressed: right_pressed }"><icon file="arrow-right" /></div></div>
			<div class="slot space" @mousedown="space_down();"><div class="key" :class="{ pressed: space_pressed }"></div></div>
			<div class="slot enter" @mousedown="enter_down();"><div class="key" :class="{ pressed: enter_pressed }"><icon file="corner-down-left" /></div></div>
		</div>
	
	</div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
	name: 'Keyboard',
	data: function() {
		return {
			active_key: true,
			enter_pressed: false,
			space_pressed: false,
			shuffle_pressed: false,
			left_pressed: false,
			right_pressed: false
		}
	},
	computed: Object.assign(mapGetters([ 'game', 'keyboard' ]), {

	}),
	methods: {
		keyup: function(touch) {
			this.$store.dispatch('keyup', { touch: touch })
		},
		keydown: function(touch) {
			this.$store.dispatch('keydown', { touch: touch })
		},

		space_down: function() {
			this.space_pressed = true
			this.$store.dispatch('space_down')
		},
		space_up: function() {
			this.space_pressed = false
		},
		enter_down: function() {
			this.enter_pressed = true
			this.$store.dispatch('enter_down')
		},
		enter_up: function() {
			this.enter_pressed = false
		},
		shuffle_down: function() {
			this.shuffle_pressed = true
			this.$store.dispatch('shuffle')
		},
		shuffle_up: function() {
			this.shuffle_pressed = false
		},
		left_down: function() {
			this.left_pressed = true
			this.$store.dispatch('arrow_down', { direction: 'left' })
		},
		left_up: function() {
			this.left_pressed = false
		},
		right_down: function() {
			this.right_pressed = true
			this.$store.dispatch('arrow_down', { direction: 'right' })
		},
		right_up: function() {
			this.right_pressed = false
		},
		back_space: function() {
			this.$store.dispatch('back_space')
		},

		mouse_up: function() {
			this.space_up()
			this.enter_up()
			this.shuffle_up()
			this.left_up()
			this.right_up()
		}

	},
	mounted: function() {
		var that = this
		window.addEventListener('keydown', function(e) {
			e.preventDefault();
			if (e.keyCode > 64 && e.keyCode < 91) {
				var key = e.key.toUpperCase()
				var touch = _.find(that.keyboard, function(touch) { return touch.letter == key })
				if (touch) that.keydown(touch)
			}
			else if (e.keyCode == 13) that.enter_down();
			else if (e.keyCode == 32) that.space_down();
			else if (e.keyCode == 37) that.left_down();
			else if (e.keyCode == 39) that.right_down();
			else if (e.keyCode == 8) that.back_space();
		});
		window.addEventListener('keyup', function(e) {
			e.preventDefault();
			if (e.keyCode > 64 && e.keyCode < 91) {
				var key = e.key.toUpperCase()
				var touch = _.find(that.keyboard, function(touch) { return touch.letter == key })
				if (touch) that.keyup(touch)
			}
			else if (e.keyCode == 13) that.enter_up()
			else if (e.keyCode == 32) that.space_up()
			else if (e.keyCode == 37) that.left_up();
			else if (e.keyCode == 39) that.right_up();
		});
	},
}
</script>

<style lang="stylus" scoped>
@import '../assets/css/app'

.keyboard
	height ((64px + 8px) * 4 + 32px)
	padding 12px 4px
	background darken(dark, 25%)
	background dark
	border-radius 8px
	display flex
	flex-direction column
	.letters, .keys
		width 100%
		display flex
		justify-content center
		align-items center
		flex-wrap wrap
		&.keys
			margin 8px 0 0 0
	.slot
		height 64px
		min-width 64px
		margin 4px
		border-radius 20px
		box-shadow 0 2px 0 0px darken(dark, 50%)
		overflow hidden
		// transition 0.25s easeOutQuart
		background darken(dark, 10%)
		&.empty
			background darken(dark, 25%)
			box-shadow 0 2px 0 0px darken(dark, 25%), inset 0 4px 0px 0px darken(dark, 40%)
		
		&.enter, &.menu
			width ((64px + 4px) * 1.5)
			margin-right 8px
		&.space
			width ((64px + 4px) * 4)

			
	
</style>



// WEBPACK FOOTER //
// src/components/Keyboard.vue